// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J4Ppn","largestCol":"styles_largestCol__1hmxS","smallestCol":"styles_smallestCol__hwOB7"};